import React from 'react';
import { Link } from 'react-router-dom';

const Footer = ({ isDarkMode }) => {
  return (
    <footer className={`mt-auto transition-all duration-300 ${
      isDarkMode 
        ? 'bg-gray-900 text-gray-300 border-t border-gray-700' 
        : 'bg-navy-900 text-white'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 py-12">
          <div className="lg:col-span-1">
            <h3 className="text-secondary-500 text-lg font-semibold mb-4">Trends Dynamiques Consulting</h3>
            <p className="text-sm leading-relaxed mb-6 opacity-90">
              Your partner in strategy, Growth and Impact across Tanzania and beyond.
            </p>
            <div className="space-y-2">
              <p className="text-sm flex items-center opacity-90">
                <span className="mr-2">📍</span>
                P.O. BOX 229, ZANZIBAR
              </p>
              <p className="text-sm flex items-center opacity-90">
                <span className="mr-2">📧</span>
                <a href="mailto:info@tdconsulting.co.tz" className="text-secondary-500 hover:text-secondary-400 transition-colors">
                  info@tdconsulting.co.tz
                </a>
              </p>
            </div>
          </div>

          <div>
            <h4 className="text-secondary-500 text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {[
                { to: '/', label: 'Home' },
                { to: '/services', label: 'Services' },
                { to: '/about', label: 'About' },
                { to: '/contact', label: 'Contact' }
              ].map(({ to, label }) => (
                <li key={to}>
                  <Link 
                    to={to} 
                    className="text-sm opacity-80 hover:text-secondary-500 hover:opacity-100 transition-all duration-300 hover:translate-x-1 inline-block"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-secondary-500 text-lg font-semibold mb-4">Our Services</h4>
            <ul className="space-y-2">
              {[
                'Monitoring & Evaluation',
                'Research & Development',
                'Tourism Advisory',
                'IT Consulting',
                'Strategic Planning'
              ].map((service) => (
                <li key={service} className="text-sm opacity-80">
                  {service}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-secondary-500 text-lg font-semibold mb-4">Office Locations</h4>
            <ul className="space-y-2 mb-6">
              <li className="text-sm opacity-80">Zanzibar Office</li>
              <li className="text-sm opacity-80">Dar es Salaam Office</li>
            </ul>
            <div className="border-t border-white/10 pt-4">
              <p className="text-sm font-medium mb-2">Business Hours:</p>
              <p className="text-xs opacity-80">Mon-Fri: 8:00 AM - 5:00 PM</p>
              <p className="text-xs opacity-80">Saturday: 9:00 AM - 1:00 PM</p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm opacity-70">
              &copy; 2025 Trends Dynamiques Consulting Limited. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <Link 
                to="/privacy" 
                className="text-sm opacity-70 hover:text-secondary-500 hover:opacity-100 transition-colors"
              >
                Privacy Policy
              </Link>
              <Link 
                to="/terms" 
                className="text-sm opacity-70 hover:text-secondary-500 hover:opacity-100 transition-colors"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;